import { RemoteAddPersonToGroup } from 'data/usecases';
import { AddPersonToGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlAddPersonToGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAddPersonToGroup =
  (): AddPersonToGroupUseCaseInterface =>
    new RemoteAddPersonToGroup(
      makeApiUrlAddPersonToGroup(),
      makeAxiosHttpClient(),
    );
